/**
 * Dashboard Service — Donor Portal
 *
 * Fetches donation statistics from the dedicated donor-dashboard endpoint.
 * Profile and serology data are provided by useMyProfileStore.
 */
import { getApiClient } from '@/core/services/api.service';
import { API_ROUTES, requirePersonId } from '@/core/config';
import type { DonorKpiData } from '../types';

type DonorDashboardData = {
  person_id: string;
  count: number;
  total_volume_ml: number;
  total_volume_used_ml: number;
  babies_helped: number;
  active_days: number | null;
};

// ─── Service factory ──────────────────────────────────────────────────────────
export function createDashboardService() {
  const api = getApiClient();
  
  async function fetchDonationStats(): Promise<DonorKpiData> {
    const personId = requirePersonId();
    const response = await api.get<DonorDashboardData>(
      `${API_ROUTES.DONOR}/donor-dashboard/${personId}`,
    );
    const d = response.data;
    return {
      totalDonations: d.count,
      totalVolumeMl: d.total_volume_ml,
      volumeUsedMl: d.total_volume_used_ml,
      babiesHelped: d.babies_helped,
      activeDays: d.active_days,
    };
  }

  return { fetchDonationStats };
}

export type DashboardService = ReturnType<typeof createDashboardService>;
